<template>
  <div v-if="!isInitial" class="ly_button">
    <MaterialButton
      @click="$emit('onTransition', prev)"
      text="前へ"
      :link="prev"
      font-size="28px"
      color="#bfbdd9"
      padding="10px 52px 10px 52px"
    />

    <MaterialButton
      @click="$emit('onTransition', next)"
      v-if="isFinished"
      text="結果"
      :link="next"
      font-size="28px"
      padding="10px 52px 10px 52px"
      :enabled = "enableGo"
    />

    <MaterialButton
      @click="$emit('onTransition', next)"
      text="次へ"
      v-else
      :link="next"
      font-size="28px"
      padding="10px 52px 10px 52px"
      :enabled = "enableGo"
    />
  </div>

  <div v-else class="ly_next_button">
    <MaterialButton
      @click="$emit('onTransition', next)"
      text="次へ"
      :link="next"
      font-size="28px"
      padding="10px 52px 10px 52px"
      :enabled = "enableGo"
    />
  </div>
</template>

<script>
import MaterialButton from '../atoms/MaterialButton'

export default {
  name: 'Navigator',
  props: {
    enableGo: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    MaterialButton,
  },
  computed: {
    isInitial() {
      // console.log(this.$route.params)
      if (parseInt(this.$route.params.id) > 1) {
        return false
      } else {
        return true
      }
    },
    isFinished() {
      if (parseInt(this.$route.params.id) > 24) {
        return true
      } else {
        return false
      }
    },
    prev() {
      return {
        name: 'problem',
        params: { id: parseInt(this.$route.params.id) - 1 },
      }
    },
    next() {
      const testId = parseInt(this.$route.params.id)
      
      if (testId > 24) {
        // 結果送信画面へ遷移
        return { name: 'sendresult' }
      } else {
        return {
          name: 'problem',
          params: { id: testId + 1 },
        }
      }
    },
  },
}
</script>

<style scoped>
.ly_button {
  position: relative;
  display: flex;
  justify-content: space-between;
  width: 100%;
  top: 177px;
  padding-bottom: 44px;
}

.ly_next_button {
  position: relative;
  text-align: end;
  width: 100%;
  top: 177px;
  padding-bottom: 44px;
}
</style>
